import React from "react";

/** Reusable placeholder for a fighter image. Prevents layout shift. */
export default function FighterImage({
  src,
  alt,
  className = "",
  imgClassName = "",
  fallback = "PORTRAIT",
}) {
  if (!src) {
    return (
      <div
        className={`bg-neutral-900 border border-neutral-800 flex items-center justify-center text-neutral-700 font-stats text-xs tracking-widest ${className}`}
      >
        {fallback}
      </div>
    );
  }
  return (
    <div className={`relative overflow-hidden bg-neutral-950 ${className}`}>
      <img
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        className={`w-full h-full object-cover ${imgClassName}`}
      />
    </div>
  );
}
